<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          class="btn-primary mr-6"
          @click="createPlanMixed()"
        >
          <v-icon>mdi-plus</v-icon>ເພີ່ມແຜນລວມ
        </v-btn>
      </v-col>
    </v-row>

    <br>
    <v-card>
      <v-card flat>
        <v-card-title>
          <v-text-field
            v-model="search"
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @keyup.enter="fetchData()"
          />
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="plans"
            :search="search"
            :disable-pagination="true"
            hide-default-footer
          >
            <template v-slot:item.plan_type="{ item }">
              <v-chip
                dark
                :color="planTypeColor(item.plan_type)"
              >
                {{ planTypeLabel(item.plan_type) }}
              </v-chip>
            </template>
            <template v-slot:item.route_plan_details_count="{ item }">
              <v-chip
                dark
                color="blue"
              >
                {{ Intl.NumberFormat().format(item.route_plan_details_count) }}
              </v-chip>
            </template>
            <template v-slot:item.package_bag="{ item }">
              <v-chip
                outlined
                color="green"
              >
                {{ Intl.NumberFormat().format(item.package_bag) }}
              </v-chip>
            </template>
            <template v-slot:item.sum_expect_trash_bag="{ item }">
              <v-chip
                outlined
                color="green"
              >
                {{ Intl.NumberFormat().format(item.sum_expect_trash_bag) }}
              </v-chip>
            </template>
            <template v-slot:item.sum_expect_trash_container="{ item }">
              <v-chip
                outlined
                color="blue"
              >
                {{ Intl.NumberFormat().format(item.sum_expect_trash_container) }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-3"
                @click="viewPage(item)"
              >
                mdi-eye
              </v-icon>
              <a
                v-for="(data, index) in item.media"
                :key="index"
                :href="data.url"
              >
                <v-icon
                  small
                  class="mr-3"
                >mdi-download</v-icon>
              </a>
              <v-icon
                small
                class="mr-3"
                @click="editPage(item.id)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item.id)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <br>
          <template>
            <Pagination
              v-if="pagination.total_pages > 1"
              :pagination="pagination"
              :offset="offset"
              @paginate="fetchData()"
            />
          </template>
        </v-card-text>
      </v-card>
    </v-card>

    <!--Name-first dialog for the mixed create flow-->
    <v-dialog
      v-model="nameDialog"
      max-width="480"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">ຕັ້ງຊື່ແຜນລວມ</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newPlanName"
            label="ຊື່ແຜນ *"
            required
            autofocus
            @keyup.enter="confirmPlanName()"
          />
          <p class="errors">
            {{ nameError }}
          </p>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="nameDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="confirmPlanName()"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Delete Modal-->
    <ModalDelete>
      <template>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="closeDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="loading"
            :disabled="loading"
            @click="deleteItemConfirm"
          >
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </template>
    </ModalDelete>
  </v-container>
</template>

<script>
export default {
  title() {
    return `Vientiane Waste Co-Dev|Route Plan`;
  },
  name: 'AllPlans',
  data() {
    return {
      tab: null,
      plans: [],
      plan: {},
      loading: false,
      planId: '',
      // Pagination
      offset: 12,
      pagination: {},
      per_page: 100,
      search: '',
      nameDialog: false,
      newPlanName: '',
      nameError: '',
      headers: [
        { text: 'ຊື່ແຜນ', value: 'name' },
        { text: 'ປະເພດແຜນ', value: 'plan_type' },
        { text: 'ຈຳນວນຈຸດ', value: 'route_plan_details_count' },
        { text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ (ຖົງ)', value: 'sum_expect_trash_bag' },
        {
          text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ (ຄອນເທນເນີ)',
          value: 'sum_expect_trash_container',
        },
        { text: 'ຖົງຄາດໝາຍ (ແພັກເກດ)', value: 'package_bag' },
        { text: 'Description', value: 'description', sortable: false },
        {
          text: 'ຈັດການຂໍ້ມູນ',
          value: 'actions',
          sortable: false,
          width: '120px',
        },
      ],
      server_errors: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    planTypeColor(planType) {
      if (planType == 'company') return 'blue';
      if (planType == 'mixed') return 'orange';
      if (planType == 'home') return 'green';
      // Backend without customer_type=all support yet: unknown, stay neutral.
      return 'grey';
    },
    planTypeLabel(planType) {
      if (planType == 'company') return 'ຫົວໜ່ວຍທຸລະກິດ';
      if (planType == 'mixed') return 'ປະສົມ';
      if (planType == 'home') return 'ຄົວເຮືອນ';
      return '-';
    },
    fetchData() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('route-plan', {
          params: {
            page: this.pagination.current_page,
            per_page: this.per_page,
            filter: this.search,
            customer_type: 'all',
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.$store.commit('Loading_State', false);
              this.plans = res.data.data.data;
              this.pagination = res.data.data.pagination;
            }, 100);
          }
        })
        .catch((error) => {
          this.$store.commit('Loading_State', false);
          if (error.response && error.response.status == 422) {
            const obj = error.response.data.errors || error.response.data.data || {};
            for (const [key, message] of Object.entries(obj)) {
              this.server_errors[key] = Array.isArray(message) ? message[0] : message;
            }
          }
        });
    },

    closeDelete() {
      this.$store.commit('modalDelete_State', false);
    },
    deleteItem(id) {
      this.planId = id;
      this.$store.commit('modalDelete_State', true);
    },

    deleteItemConfirm() {
      this.$store.commit('Loading_State', true);
      this.$axios
        .delete(`route-plan/${this.planId}`)
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.$store.commit('Loading_State', false);
              this.$store.commit('Toast_State', {
                value: true,
                color: 'success',
                msg: res.data.message,
              });
              this.$store.commit('modalDelete_State', false);
              this.fetchData();
            }, 300);
          }
        })
        .catch((error) => {
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: error.response
              ? error.response.data.message
              : 'Something went wrong',
          });
          this.$store.commit('modalDelete_State', false);
          this.$store.commit('Loading_State', false);
        });
    },

    createPlanMixed() {
      this.newPlanName = '';
      this.nameError = '';
      this.nameDialog = true;
    },
    confirmPlanName() {
      if (!this.newPlanName || !this.newPlanName.trim()) {
        this.nameError = 'ກະລຸນາຕັ້ງຊື່ແຜນກ່ອນ';
        return;
      }
      this.nameDialog = false;
      this.$router.push({
        name: 'SelectMixedRoutePlan',
        query: { name: this.newPlanName.trim() },
      });
    },

    editPage(id) {
      this.$router.push({
        name: 'EditPlan',
        params: { id },
      });
    },
    viewPage(item) {
      // Pure home plans keep the home view chain; company and mixed plans
      // use the company view, which renders per-member rows for both types.
      this.$openRoute({
        name: item.plan_type == 'home' ? 'ViewPlan' : 'ViewCompanyRoutePlan',
        params: { id: item.id },
      });
    },
    download(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="scss">
@import "../../../../../public/scss/main.scss";
</style>
